<template lang="pug">
    div
        v-container(grid-list-md v-if="master" )
            v-layout(wrap)
                v-flex(lg6 md6 xs12)
                    v-text-field(dense v-model="master.statusName"  label="Status Upload" readonly)
                        template(v-slot:prepend)
                            v-icon(:color="getColor(master.status)") mdi-chart-bubble
                v-flex(lg6 md6 xs12 v-if="master.referenceId")
                    v-text-field(dense v-model="master.referenceId" label="No. Referensi" readonly)
                        template(v-slot:prepend)
                            v-icon(color="primary") mdi-checkbox-marked-outline
                v-flex(lg8 md8 xs12 v-if="master.errorMessage")
                    v-text-field(dense v-model="master.errorMessage" label="Pesan Kesalahan" readonly)
                        template(v-slot:prepend)
                            v-icon(color="warning") mdi-alert-circle
                v-flex(lg8 md8 xs12 v-if="master.reason")
                    v-text-field(dense v-model="master.reason" label="Alasan Pembatalan" readonly)
                        template(v-slot:prepend)
                            v-icon(color="warning") mdi-alert-circle
                v-flex(lg6 md6 xs12 v-if="master.userEntry")
                    v-text-field(dense v-model="master.userEntry" label="Entri Upload" readonly)
                        template(v-slot:prepend)
                            v-icon(color="green accent-1") mdi-check-circle
                        template(v-slot:append)
                            v-chip(small color="green accent-1" class="my-1") {{master.dateEntry | datetimeformat}}
                v-flex(lg6 md6 xs12 v-if="master.userVerify")
                    v-text-field(dense v-model="master.userVerify" label="Verifikasi Upload" readonly)
                        template(v-slot:prepend)
                            v-icon(color="green accent-2") mdi-check-circle
                        template(v-slot:append)
                            v-chip(small color="green accent-2" class="my-1") {{master.dateVerify | datetimeformat}}
                v-flex(lg6 md6 xs12 v-if="master.userApprove")
                    v-text-field(dense v-model="master.userApprove" label="Approve Upload" readonly)
                        template(v-slot:prepend)
                            v-icon(color="info") mdi-check-circle
                        template(v-slot:append)
                            v-chip(small color="info" class="my-1") {{master.dateApprove | datetimeformat}}
                v-flex(lg6 md6 xs12 v-if="master.userReject")
                    v-text-field(dense v-model="master.userReject" label="Pembatalan Upload" readonly)
                        template(v-slot:prepend)
                            v-icon(color="red lighten-3") mdi-check-circle
                        template(v-slot:append)
                            v-chip(small color="red lighten-3" class="my-1") {{master.dateReject | datetimeformat}}
            f-upload-transaction-table(:upload="master.dataResponse ? master.dataResponse : master.dataRequest" :monitoring="monitoring" v-on:hideButton="eventEmit('hideButton')" v-on:showButton="eventEmit('showButton')")
</template>
<script>
export default {
    name: "FUploadTransactionContent",
    props: ["master", "monitoring"],
    methods: {
        getColor(status){
            if (status == 'ENTRY') {
                return "green accent-1";
            } else if(status == 'VERIFY'){
                return "green accent-2";
            } else if(status == 'SUSPECT'){
                return "warning";
            } else if(status == 'SUCCESS'){
                return "info";
            } else if(status == 'REJECT'){
                return "red lighten-3";
            } else if(status == 'AUTOTRX'){
                return "success";
            } else{
                return "error";
            }
        },
        eventEmit(event){
            this.$emit(event)
        }
    },
}
</script>